import ApiClient from '@/libs/http-client'

const CurrencyService = {
    get() {
        return ApiClient.get('/api/currencies')
    },
}

export default CurrencyService
